import React, { useState, useEffect, useRef } from "react";
import aerox155_vers from "../assets/gallery/aerox155_vers.jpg";
import fz_rave from "../assets/gallery/fz_rave.jpg";
import fzs_fi_hybrid from "../assets/gallery/fzs-fi-hybrid.jpg";
import fzs_fi_v4_dlx from "../assets/gallery/fzs-fi-v4-dlx.jpg";
import fzx_hybrid from "../assets/gallery/fzx_hybrid.jpg";
import mt15v2 from "../assets/gallery/mt15v2.jpg";
import r15m from "../assets/gallery/r15m.jpg";
import r15s from "../assets/gallery/r15s.jpg";
import rayZR from "../assets/gallery/rayZR.jpg";

const galleryImages = [
  {
    src: r15m,
    title: "Yamaha R15M",
    caption: "The True Racing Legend - Born on the Track.",
  },
  {
    src: mt15v2,
    title: "Yamaha MT-15 V2.0",
    caption: "Unleash Your Dark Side - Aggressive Hyper-Naked.",
  },
  {
    src: aerox155_vers,
    title: "Yamaha Aerox 155",
    caption: "The R-DNA Scooter - Performance Redefined.",
  },
  {
    src: fzx_hybrid,
    title: "Yamaha FZ-X",
    caption: "Ride Free - Retro Styling meets Neo Technology.",
  },
  {
    src: fzs_fi_v4_dlx,
    title: "Yamaha FZ-S FI V4",
    caption: "Lord of the Streets - Dynamic Comfort & Style.",
  },
  {
    src: rayZR,
    title: "Yamaha RayZR 125",
    caption: "The Cyber Scooter - Sporty, Sleek & Fuel Efficient.",
  },
  {
    src: fzs_fi_hybrid,
    title: "Yamaha FZ-S Hybrid",
    caption: "Empower Your Journeys - Smarter Urban Commuting.",
  },
  {
    src: r15s,
    title: "Yamaha R15S",
    caption: "Pure Aerodynamic Perfection - Aggressive Track Stance.",
  },
  {
    src: fz_rave,
    title: "Yamaha FZ Series",
    caption: "Uncompromising Power - Street Dominance.",
  },
];

const GalleryCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [cardsToShow, setCardsToShow] = useState(3);
  const [lightboxImage, setLightboxImage] = useState(null);
  const sliderRef = useRef(null);

  // Responsive breakpoints logic
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 640) {
        setCardsToShow(1); // 1 card on mobile
      } else if (window.innerWidth < 1024) {
        setCardsToShow(2); // 2 cards on tablet
      } else {
        setCardsToShow(3); // 3 cards on desktop
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const totalSlides = galleryImages.length;
  const maxIndex = totalSlides - cardsToShow;

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? maxIndex : prev - 1));
  };

  // Autoplay function
  useEffect(() => {
    const autoplay = setInterval(() => {
      nextSlide();
    }, 4500);
    return () => clearInterval(autoplay);
  }, [currentIndex, cardsToShow]);

  const openLightbox = (img) => {
    setLightboxImage(img);
  };

  const closeLightbox = () => {
    setLightboxImage(null);
  };

  const navigateLightbox = (direction) => {
    if (!lightboxImage) return;
    const currentPhotoIndex = galleryImages.findIndex((img) => img.src === lightboxImage.src);
    let nextPhotoIndex = currentPhotoIndex + direction;
    if (nextPhotoIndex < 0) nextPhotoIndex = totalSlides - 1;
    if (nextPhotoIndex >= totalSlides) nextPhotoIndex = 0;
    setLightboxImage(galleryImages[nextPhotoIndex]);
  };

  return (
    <section id="photos_content_container" className="py-10 bg-gray-900 overflow-hidden relative border-t border-b border-gray-800">
      <div className="max-w-7xl mx-auto px-6 relative">
        
        {/* Section Header */}
        <div className="flex flex-col md:flex-row justify-between items-center mb-6 text-center md:text-left">
          <div>
            <h2 className="text-3xl font-extrabold text-white tracking-wide uppercase">
              Yamaha Diaries
            </h2>
            <p className="text-gray-400 mt-1 text-sm sm:text-base">
              Lifestyle captures from the <span className="text-yellow-400 font-bold">No. 1 Yamaha Dealer in Delhi</span> - Excellent Motors.
            </p>
          </div>

          {/* Navigation buttons */}
          <div className="flex space-x-3 mt-6 md:mt-0 z-20">
            <button
              onClick={prevSlide}
              className="w-12 h-12 rounded-full border border-gray-700 bg-gray-800/80 hover:bg-yellow-500 hover:text-blue-950 text-white flex items-center justify-center transition shadow-lg"
              aria-label="Previous Slide"
            >
              <i className="fa-solid fa-arrow-left text-lg"></i>
            </button>
            <button
              onClick={nextSlide}
              className="w-12 h-12 rounded-full border border-gray-700 bg-gray-800/80 hover:bg-yellow-500 hover:text-blue-950 text-white flex items-center justify-center transition shadow-lg"
              aria-label="Next Slide"
            >
              <i className="fa-solid fa-arrow-right text-lg"></i>
            </button>
          </div>
        </div>

        {/* Carousel Slider Window */}
        <div className="relative w-full overflow-hidden">
          <div
            ref={sliderRef}
            className="flex transition-transform duration-500 ease-in-out"
            style={{
              transform: `translateX(-${currentIndex * (100 / totalSlides)}%)`,
              width: `${(totalSlides * 100) / cardsToShow}%`,
            }}
          >
            {galleryImages.map((image, index) => (
              <div
                key={index}
                className="px-1"
                style={{ width: `${100 / totalSlides}%` }}
              >
                <div
                  onClick={() => openLightbox(image)}
                  className="group relative cursor-pointer overflow-hidden rounded-xl border border-gray-800 bg-gray-950 shadow-xl transition-all duration-300"
                >
                  {/* Image Aspect ratio box */}
                  <div className="aspect-[3/2] w-full overflow-hidden bg-gray-900">
                    <img
                      src={image.src}
                      alt={`${image.title} - Yamaha Diaries Lifestyle Capture`}
                      className="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-105"
                      loading="lazy"
                    />
                  </div>

                  {/* Dark elegant overlay block on hover */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-5">
                    <span className="text-yellow-400 font-extrabold text-xs uppercase tracking-widest mb-1">
                      Explore Performance
                    </span>
                    <h3 className="text-white text-lg font-bold">
                      {image.title}
                    </h3>
                    <p className="text-gray-300 text-xs mt-1 font-medium leading-normal">
                      {image.caption}
                    </p>
                    <div className="absolute top-4 right-4 w-9 h-9 rounded-full bg-yellow-500 text-blue-950 flex items-center justify-center shadow-lg transform translate-y-2 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-300">
                      <i className="fa-solid fa-magnifying-glass text-sm"></i>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Dynamic Pagination dots */}
        <div className="flex justify-center space-x-2.5 mt-8">
          {Array.from({ length: maxIndex + 1 }).map((_, idx) => (
            <button
              key={idx}
              onClick={() => setCurrentIndex(idx)}
              className={`h-2.5 rounded-full transition-all duration-300 ${
                currentIndex === idx
                  ? "w-8 bg-yellow-500"
                  : "w-2.5 bg-gray-700 hover:bg-gray-500"
              }`}
              aria-label={`Go to slide ${idx + 1}`}
            ></button>
          ))}
        </div>
      </div>

      {/* Full-screen Lightbox Overlay */}
      {lightboxImage && (
        <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/90 backdrop-blur-md p-4 animate-fadeIn transition-all duration-300">
          
          {/* Close trigger */}
          <button
            onClick={closeLightbox}
            className="absolute top-6 right-6 z-[1010] w-12 h-12 rounded-full bg-gray-800/80 hover:bg-yellow-500 hover:text-blue-950 text-white flex items-center justify-center transition shadow-2xl"
            aria-label="Close Lightbox"
          >
            <i className="fa-solid fa-xmark text-xl"></i>
          </button>

          {/* Lightbox arrows */}
          <button
            onClick={() => navigateLightbox(-1)}
            className="absolute left-6 z-[1010] w-14 h-14 rounded-full bg-gray-800/60 hover:bg-yellow-500 hover:text-blue-950 text-white hidden md:flex items-center justify-center transition shadow-2xl"
            aria-label="Previous Image"
          >
            <i className="fa-solid fa-chevron-left text-2xl"></i>
          </button>
          <button
            onClick={() => navigateLightbox(1)}
            className="absolute right-6 z-[1010] w-14 h-14 rounded-full bg-gray-800/60 hover:bg-yellow-500 hover:text-blue-950 text-white hidden md:flex items-center justify-center transition shadow-2xl"
            aria-label="Next Image"
          >
            <i className="fa-solid fa-chevron-right text-2xl"></i>
          </button>

          {/* Lightbox Content Container */}
          <div className="max-w-4xl max-h-[85vh] flex flex-col items-center relative select-none">
            <img
              src={lightboxImage.src}
              alt={lightboxImage.title}
              className="max-w-full max-h-[75vh] object-contain rounded-lg border border-gray-800 shadow-2xl"
            />
            <div className="text-center mt-4 text-white">
              <h4 className="text-xl font-bold text-yellow-400">{lightboxImage.title}</h4>
              <p className="text-gray-400 text-xs sm:text-sm mt-1">{lightboxImage.caption}</p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default GalleryCarousel;
